module.exports = __webpack_public_path__ + "static/why-download-fde73fa58da6aa772e183cc4b45adbfd.png";